'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var themeTools = require('@chakra-ui/theme-tools');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _lg, _md, _sm;
var $size = themeTools.cssVar('close-button-size');
var baseStyle = {
  w: [$size.reference],
  h: [$size.reference],
  opacity: 0.7,
  transition: '100ms color ease-in-out',
  fontSize: 'xl',
  _hover: {
    opacity: 1
  },
  _disabled: {
    color: 'gray.200',
    cursor: 'not-allowed'
  }
};
var sizes = {
  lg: (_lg = {}, _defineProperty__default["default"](_lg, $size.variable, '40px'), _defineProperty__default["default"](_lg, "fontSize", '18px'), _lg),
  md: (_md = {}, _defineProperty__default["default"](_md, $size.variable, '32px'), _defineProperty__default["default"](_md, "fontSize", '18px'), _md),
  sm: (_sm = {}, _defineProperty__default["default"](_sm, $size.variable, '24px'), _defineProperty__default["default"](_sm, "fontSize", '16px'), _sm)
};
var defaultProps = {
  size: 'md'
};
var CloseButton = {
  baseStyle: baseStyle,
  defaultProps: defaultProps,
  sizes: sizes
};
exports["default"] = CloseButton;